import { useNavigate } from "react-router-dom";

const GOLD = "#AC8E66";
const BORDER = "#2a2a2a";
const TEXT = "#e8e0d4";
const MUTED = "#7a7060";
const SURFACE = "#1A1A1A";

const STUDIOS = [
  { id: "01", name: "Converter Studio", desc: "Markdown & Editor.js konvertieren" },
  { id: "02", name: "Content AI Studio", desc: "7 Plattformen, lokal oder Cloud-KI" },
  { id: "03", name: "Doc Studio", desc: "README, CHANGELOG, API-Docs" },
];

const ZenPostStudioLandingPageHero = () => {
  const navigate = useNavigate();

  return (
    <section
      style={{
        borderTop: `1px solid ${BORDER}`,
        background: "#111111",
        fontFamily:
          'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          padding: "80px 32px",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "64px",
          alignItems: "center",
        }}
        className="zps-hero-grid"
      >
        {/* Left: Text */}
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "32px",
            }}
          >
            <span
              style={{
                border: `1px solid ${GOLD}`,
                color: GOLD,
                fontSize: "0.6rem",
                padding: "2px 8px",
                letterSpacing: "0.14em",
                textTransform: "uppercase",
              }}
            >
              ZenPost Studio
            </span>
            <span
              style={{
                border: `1px solid ${BORDER}`,
                color: MUTED,
                fontSize: "0.6rem",
                padding: "2px 8px",
                letterSpacing: "0.14em",
                textTransform: "uppercase",
              }}
            >
              Open Beta · Kostenlos
            </span>
          </div>

          <h2
            style={{
              color: TEXT,
              fontSize: "clamp(1.5rem, 3vw, 2.2rem)",
              fontWeight: 700,
              lineHeight: 1.25,
              margin: "0 0 16px 0",
            }}
          >
            Schreibe einmal.{" "}
            <span style={{ color: GOLD }}>Publiziere überall.</span>
          </h2>

          <p
            style={{
              color: MUTED,
              fontSize: "0.85rem",
              lineHeight: 1.75,
              margin: "0 0 40px 0",
            }}
          >
            Desktop-App für Entwickler und Creator — Inhalte transformieren,
            plattformspezifisch optimieren, Docs generieren. Offline-first, ohne Abo.
          </p>

          {/* Studio-Liste */}
          <div style={{ marginBottom: "40px" }}>
            {STUDIOS.map((s) => (
              <div
                key={s.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  padding: "12px 0",
                  borderBottom: `1px solid ${BORDER}`,
                }}
              >
                <span style={{ color: GOLD, fontSize: "0.65rem", minWidth: "28px" }}>
                  {s.id}
                </span>
                <span style={{ color: TEXT, fontSize: "0.8rem", fontWeight: 600 }}>
                  {s.name}
                </span>
                <span style={{ color: MUTED, fontSize: "0.75rem" }}>{s.desc}</span>
              </div>
            ))}
          </div>

          <button
            onClick={() => navigate("/zenpost-studio")}
            style={{
              background: GOLD,
              color: "#111",
              border: "none",
              padding: "12px 28px",
              fontSize: "0.8rem",
              letterSpacing: "0.08em",
              fontWeight: 700,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            Mehr erfahren →
          </button>
        </div>

        {/* Right: Screenshot */}
        <div>
          <div
            style={{
              border: `1px solid ${BORDER}`,
              background: SURFACE,
              overflow: "hidden",
            }}
          >
            <img
              src="/images/zenpoststudio/wilkkomen.webp"
              alt="ZenPost Studio – Übersicht"
              style={{ width: "100%", display: "block" }}
              loading="lazy"
            />
          </div>
          <div
            style={{
              marginTop: "12px",
              display: "flex",
              gap: "8px",
            }}
          >
            <div
              style={{
                flex: 1,
                border: `1px solid ${BORDER}`,
                background: SURFACE,
                overflow: "hidden",
              }}
            >
              <img
                src="/images/zenpoststudio/projekt.webp"
                alt="ZenPost – Plattform Export"
                style={{ width: "100%", display: "block" }}
                loading="lazy"
              />
            </div>
            <div
              style={{
                flex: 1,
                border: `1px solid ${BORDER}`,
                background: SURFACE,
                overflow: "hidden",
              }}
            >
              <img
                src="/images/zenpoststudio/docstudio.png"
                alt="ZenPost – Doc Studio"
                style={{ width: "100%", display: "block" }}
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .zps-hero-grid {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default ZenPostStudioLandingPageHero;
